"use strict";
// tslint:disable
/**
 * Model Catalog
 * This is the API of the Software Description Ontology at [https://w3id.org/okn/o/sdm](https://w3id.org/okn/o/sdm)
 *
 * The version of the OpenAPI document: v1.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogIdentifierToJSON = exports.CatalogIdentifierFromJSONTyped = exports.CatalogIdentifierFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CatalogIdentifierFromJSON(json) {
    return CatalogIdentifierFromJSONTyped(json, false);
}
exports.CatalogIdentifierFromJSON = CatalogIdentifierFromJSON;
function CatalogIdentifierFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hasDefaultValue': !runtime_1.exists(json, 'hasDefaultValue') ? undefined : json['hasDefaultValue'],
        'hasMaximumAcceptedValue': !runtime_1.exists(json, 'hasMaximumAcceptedValue') ? undefined : json['hasMaximumAcceptedValue'],
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'hasDataType': !runtime_1.exists(json, 'hasDataType') ? undefined : json['hasDataType'],
        'hasFixedValue': !runtime_1.exists(json, 'hasFixedValue') ? undefined : json['hasFixedValue'],
        'hasPresentation': !runtime_1.exists(json, 'hasPresentation') ? undefined : json['hasPresentation'].map(_1.VariablePresentationFromJSON),
        'label': !runtime_1.exists(json, 'label') ? undefined : json['label'],
        'recommendedIncrement': !runtime_1.exists(json, 'recommendedIncrement') ? undefined : json['recommendedIncrement'],
        'type': !runtime_1.exists(json, 'type') ? undefined : json['type'],
        'hasMinimumAcceptedValue': !runtime_1.exists(json, 'hasMinimumAcceptedValue') ? undefined : json['hasMinimumAcceptedValue'],
        'hasAcceptedValues': !runtime_1.exists(json, 'hasAcceptedValues') ? undefined : json['hasAcceptedValues'],
        'adjustsVariable': !runtime_1.exists(json, 'adjustsVariable') ? undefined : json['adjustsVariable'].map(_1.VariableFromJSON),
        'relevantForIntervention': !runtime_1.exists(json, 'relevantForIntervention') ? undefined : json['relevantForIntervention'].map(_1.InterventionFromJSON),
        'position': !runtime_1.exists(json, 'position') ? undefined : json['position'],
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'usesUnit': !runtime_1.exists(json, 'usesUnit') ? undefined : json['usesUnit'].map(_1.UnitFromJSON),
        'hasStepSize': !runtime_1.exists(json, 'hasStepSize') ? undefined : json['hasStepSize'],
    };
}
exports.CatalogIdentifierFromJSONTyped = CatalogIdentifierFromJSONTyped;
function CatalogIdentifierToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hasDefaultValue': value.hasDefaultValue,
        'hasMaximumAcceptedValue': value.hasMaximumAcceptedValue,
        'description': value.description,
        'hasDataType': value.hasDataType,
        'hasFixedValue': value.hasFixedValue,
        'hasPresentation': value.hasPresentation === undefined ? undefined : value.hasPresentation.map(_1.VariablePresentationToJSON),
        'label': value.label,
        'recommendedIncrement': value.recommendedIncrement,
        'type': value.type,
        'hasMinimumAcceptedValue': value.hasMinimumAcceptedValue,
        'hasAcceptedValues': value.hasAcceptedValues,
        'adjustsVariable': value.adjustsVariable === undefined ? undefined : value.adjustsVariable.map(_1.VariableToJSON),
        'relevantForIntervention': value.relevantForIntervention === undefined ? undefined : value.relevantForIntervention.map(_1.InterventionToJSON),
        'position': value.position,
        'id': value.id,
        'usesUnit': value.usesUnit === undefined ? undefined : value.usesUnit.map(_1.UnitToJSON),
        'hasStepSize': value.hasStepSize,
    };
}
exports.CatalogIdentifierToJSON = CatalogIdentifierToJSON;
